import { render, staticRenderFns } from "./TipoProducto.vue?vue&type=template&id=cec45752&"
import script from "./TipoProducto.vue?vue&type=script&lang=js&"
export * from "./TipoProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports